/**
 * "OK, show me" (#1465 step 4): after the conflict dialog closes, the job's
 * card glows where it now sits for a few seconds. A context rather than a
 * prop threaded through three lane components — the block is the only reader.
 */
import { createContext, useContext, type ReactNode } from "react";

const HighlightJobContext = createContext<string | null>(null);

export function HighlightJobProvider({ jobId, children }: { jobId: string | null; children: ReactNode }) {
    return <HighlightJobContext.Provider value={jobId}>{children}</HighlightJobContext.Provider>;
}

/** The job id currently asked to glow, or null. */
export function useHighlightedJobId(): string | null {
    return useContext(HighlightJobContext);
}

/** How long the glow lasts, ms. Matches the mockup's "a few seconds". */
export const HIGHLIGHT_MS = 6_000;
